module.exports = __webpack_public_path__ + "img/yaoqingman.fbb1135c.png";